import { fetchWithBearer } from '@braincube/jwt-browser';

function clearCache(apiName) {
    fetchWithBearer(`https://${apiName}.${window.BC_API_ENDPOINTS_CONF.base}/braincube-web/rest/session/emptyCache`, {
        method: 'POST',
    });
}

export default clearCache;
